import Address from '@/locations/models/address'
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import axios from '@/app/axios'
import Responses from '@/app/utils/responses'
import isEqual from 'lodash/isEqual'
import LatLng from '@/locations/models/lat-lng'

@Component
export default class AddressInput extends Vue {
  @Prop({ required: true })
  private value!: Address

  @Prop({ default: false })
  private withCountry!: boolean

  @Prop({ default: true })
  private withStreet!: boolean

  @Prop({ default: false })
  private showCountryCode!: boolean

  @Prop({ default: false })
  private hasLocation!: boolean

  @Prop({ default: false })
  private immediate!: boolean

  private address: Address = this.normalize(this.value)

  public async locateAsync() {
    if (this.address.city) {
      console.log('maps start')
      const res = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${this
          .address.postalCode + ',Austria'}&key=${
          this.$env.VUE_APP_GOOGLE_API_KEY
        }`
      )
      if (res.ok) {
        let geo = JSON.parse(await res.text())
        console.log('Geo: ' + JSON.stringify(geo))
        if (geo.results) {
          if (geo.results.length > 0) {
            const loc = geo.results[0].geometry.location
            this.address.location.latitude = loc.lat
            this.address.location.longitude = loc.lng
            return true
          }
        }
      } else {
        console.log('Error: ' + JSON.stringify(res))
        // set lat/lng to Innsbruck
        this.address.location.latitude = 47.2658
        this.address.location.longitude = 11.3923
      }
    }
    return false
  }

  @Watch('value', { deep: true })
  private valueChanged(val: Address, old: Address) {
    if (isEqual(val, old) === false) {
      this.address = this.normalize(val)
    }
  }

  @Watch('address', { deep: true })
  private addressChanged(val: Address, old: Address) {
    this.$emit('input', val)
  }

  private normalize(val: Address) {
    val = val || new Address()
    val.location = val.location || new LatLng()
    return val
  }
}
